import { ResearchArea } from '@/types'

export const DEFAULT_RESEARCH_AREA: Omit<ResearchArea, 'id'> = {
  location_lat: undefined,
  location_long: undefined,
  location_name: '',
  research_area_protocols: [],
  graphics: [],
}
